import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { FinanceDtoKeysEnum } from '@zaoblako/shared/modules/finance/enums/finance-dto-keys.enum';

import * as yup from 'yup';

export interface NdsFindInterface {
  id: number;
  name: string;
  amount: number;
}

export const NdsFindDto = SerdeDtoClass.create<NdsFindInterface>(FinanceDtoKeysEnum.NDS_FIND_DTO, {
  id: {
    label: 'Номер',
    serializer: yup.number(),
  },
  name: {
    sortable: true,
    label: 'Имя',
    serializer: yup.string(),
  },
  amount: {
    label: 'Значение',
    serializer: yup.number(),
  },
});
